// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"Modal_Overlay__33Ypd","Modal":"Modal_Modal__3ihEg"};